export const API_URL = "https://fast-food-ecommerce1.herokuapp.com"
export const TOKEN ="token";
export const PRODUCTS="products";